import React from "react";

import { Environment } from "@packages/client/src/model/Environment";
import { useIntl } from "react-intl";

import Error from "Components/Error";
import Checkbox from "ds/Checkbox";
import useMediaQuery from "Hooks/useMediaQuery";

import { DeploymentTypeChangeModal } from "./DeploymentTypeChangeModal";
import * as S from "./DeploymentTypeSetting.styles";

type Props = {
  environment: Environment;
  onDeploymentTypeChange: (value: boolean) => void;
  onChangeDeploymentTypeSave: (e) => void;
  confirmDeploymentTypeChangeModal: boolean;
  closeModal: () => void;
  cancel: () => void;
  disabled: boolean;
  isAutomaticDeployment: boolean;
  errors?: {
    message: string;
  };
};

const DeploymentTypeSetting = ({
  environment,
  onDeploymentTypeChange,
  onChangeDeploymentTypeSave,
  confirmDeploymentTypeChangeModal,
  closeModal,
  cancel,
  errors,
  disabled = false,
  isAutomaticDeployment
}: Props) => {
  const intl = useIntl();

  const onMobile = useMediaQuery("(max-width: 768px)");

  return (
    <>
      <S.SettingWrapper>
        <Checkbox
          disabled={!environment?.hasPermission("#edit") || disabled}
          label={intl.formatMessage<React.ReactNode>(
            {
              id: onMobile
                ? "environment.settings.deployment_type.title"
                : "environment.settings.deployment_type"
            },
            {
              b: chunks => <strong>{chunks}</strong>
            }
          )}
          checked={isAutomaticDeployment}
          onCheckedChanged={onDeploymentTypeChange}
          forId="environment-deployemnt-type-switch"
          id={
            onMobile
              ? "environment.settings.deployment_type.title"
              : "environment.settings.deployment_type"
          }
        />
        {onMobile && (
          <S.AutomaticDeploymentDescription>
            {intl.formatMessage({
              id: "environment.settings.deployment_type.description"
            })}
          </S.AutomaticDeploymentDescription>
        )}
        {errors?.message && (
          <S.ErrorWrapper>
            <Error>{errors?.message}</Error>
          </S.ErrorWrapper>
        )}
      </S.SettingWrapper>
      <DeploymentTypeChangeModal
        confirmDeploymentTypeChangeModal={confirmDeploymentTypeChangeModal}
        closeModal={closeModal}
        onChangeDeploymentTypeSave={onChangeDeploymentTypeSave}
        cancel={cancel}
      />
    </>
  );
};

export default DeploymentTypeSetting;
